import React, { useState } from "react";
import { Container, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import emailjs from "@emailjs/browser";
import "./Login.css";

export default function Login() {

    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);


    const handleLogin = async () => {

        // =========================
        // CHECK EMPTY FIELDS
        // =========================

        if (!email || !password) {

            alert(
                "⚠️ Please enter your email and password!"
            );

            return;
        }


        // =========================
        // GET SIGNUP USER
        // =========================

        const savedUser = JSON.parse(
            localStorage.getItem("user")
        );


        // =========================
        // CHECK EMAIL & PASSWORD
        // =========================

        if (
            savedUser &&
            email === savedUser.email &&
            password === savedUser.password
        ) {

            setLoading(true);


            // =========================
            // SAVE LOGIN STATUS
            // =========================

            localStorage.setItem(
                "isLoggedIn",
                "true"
            );

            localStorage.setItem(
                "userEmail",
                savedUser.email
            );


            // =========================
            // CUSTOMER EMAIL
            // =========================

            const customerEmail =
                savedUser.email;


            // =========================
            // EMAILJS VARIABLES
            // =========================

            const templateParams = {

                // EmailJS Template:
                // To Email = {{to_email}}

                to_email: customerEmail,

                user_name:
                    savedUser.name,

                user_email:
                    customerEmail,

                subject:
                    "Login Successful - Srineevi Coffee House"

            };


            console.log(
                "📧 MAIL TO CUSTOMER:",
                customerEmail
            );


            // =========================
            // SEND EMAIL
            // =========================

            try {

                const response =
                    await emailjs.send(

                        "service_qbq1lp9",

                        "template_redf2p8",

                        templateParams,

                        {
                            publicKey:
                                "Wgjv8Tc07Rk4_kZaL"
                        }

                    );


                console.log(
                    "✅ EMAIL SENT:",
                    response.status,
                    response.text
                );


                setSuccess(true);


                // =========================
                // GO HOME
                // =========================

                setTimeout(() => {

                    navigate("/");

                    window.location.reload();

                }, 1500);


            } catch (error) {

                console.error(
                    "❌ EMAIL ERROR:",
                    error
                );


                alert(
                    "⚠️ Login successful!\n\n" +
                    "But email notification could not be sent."
                );


                setSuccess(true);


                setTimeout(() => {

                    navigate("/");

                    window.location.reload();

                }, 1500);

            } finally {

                setLoading(false);

            }


        } else {

            alert(
                "❌ Invalid Email or Password"
            );

        }

    };


    return (

        <div className="login-page">

            <Container className="login-container">

                <h2>
                    Welcome Back 👋
                </h2>

                <p>
                    Please sign in to continue
                </p>


                {/* SUCCESS MESSAGE */}

                {success && (

                    <Alert variant="success">

                        🎉 Login Successful!

                        <br />

                        📧 Notification sent to your email.

                    </Alert>

                )}


                {/* EMAIL */}

                <input
                    id="login-email"
                    name="email"
                    type="email"
                    className="input-box"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) =>
                        setEmail(e.target.value)
                    }
                    autoComplete="email"
                />


                {/* PASSWORD */}

                <input
                    id="login-password"
                    name="password"
                    type="password"
                    className="input-box"
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) =>
                        setPassword(e.target.value)
                    }
                    autoComplete="current-password"
                />


                {/* FORGOT PASSWORD */}

                <div className="forgot-password">

                    <span
                        onClick={() =>
                            alert(
                                "Forgot Password feature coming soon!"
                            )
                        }
                    >
                        Forgot Password?
                    </span>

                </div>


                {/* LOGIN BUTTON */}

                <button
                    className="button-box"
                    onClick={handleLogin}
                    disabled={loading}
                >

                    {loading
                        ? "Sending..."
                        : "Sign In"
                    }

                </button>


                {/* SIGN UP */}

                <p className="signup-text">

                    Don't have an account?{" "}

                    <span
                        onClick={() =>
                            navigate("/signup")
                        }
                        style={{
                            color: "#0d6efd",
                            cursor: "pointer",
                            fontWeight: "bold"
                        }}
                    >
                        Sign Up
                    </span>

                </p>

            </Container>

        </div>

    );
}